import type { MouseEvent } from 'react';
import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components-new/typography/typography';

export interface NavigationItemProps {
  link: string;
  title: string;
  variant?: 'neutral' | 'purple';
  isSelected?: boolean;
  className?: string;
  typographyClassName?: string;
  onClick?: (evt: MouseEvent<HTMLAnchorElement>) => void;
}

const NavigationItem: React.FC<NavigationItemProps> = ({
  link,
  title,
  variant = 'neutral',
  isSelected,
  onClick,
  className,
  typographyClassName,
}) => {
  const containerClassName = twMerge(
    'group',
    isSelected && variant === 'neutral' && 'border-primary-400',
    isSelected && variant === 'purple' && 'border-white',
    isSelected && 'border-l-2 md:border-l-0 md:border-b-2',
  );
  const linkClassName = twMerge(
    'group w-full md:w-fit md:flex md:flex-row md:justify-center md:items-center',
    'py-1 md:my-0 md:py-2 md:px-4 xl:px-6 md:h-full',
    'rounded hover:cursor-pointer hover:bg-background-hover',
    className,
  );
  const titleClassName = twMerge(
    'py-4 pl-4 md:my-0 w-full md:w-auto md:py-0 md:pl-0 font-normal',
    variant === 'purple' && 'text-white md:group-hover:text-purple',
    variant === 'neutral' && 'text-gray-500 group-active:text-gray-800',
    isSelected && variant === 'neutral' && 'text-primary-400',
    isSelected && variant === 'purple' && 'text-white',
    typographyClassName,
  );
  return (
    <div className={containerClassName}>
      <a href={link} className={linkClassName} onClick={onClick}>
        <Typography variant="ui-nav-main" as="p" className={titleClassName}>
          {title}
        </Typography>
      </a>
    </div>
  );
};

export default NavigationItem;
